
import React from "react";
import PageHeader from "../../components/PageHeader";
import VehicleUpdateComponent from "../../components/Vehicle/VehicleUpdate";

class VehicleUpdate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Vehicle Update"
                            Breadcrumb={[
                                { name: "Categories", navigate: "/categories" },
                                { name: "Vehicle Update", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <VehicleUpdateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VehicleUpdate;
